import { Box } from "@chakra-ui/layout";
import { SelectProps } from "antd";
import { CoresVeiculo } from "core/features/veiculo/veiculo.data";
import { useState } from "react";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";

export interface SelectCorVeiculoProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  isInvalid?: boolean;
  errorMessage?: string;
}

function SelectCorVeiculo({
  value,
  onChange,
  isInvalid,
  errorMessage,
  ...rest
}: SelectCorVeiculoProps) {
  const [search, setSearch] = useState<string | undefined>();

  return (
    <SelectBaseAntd
      isInvalid={isInvalid}
      size="large"
      placeholder="Selecione a cor"
      style={{ width: "100%", flexGrow: 1, flex: 1 }}
      value={value || undefined}
      onChange={onChange}
      {...rest}
      showSearch
      allowClear={false}
      searchValue={search}
      onSearch={setSearch}
      optionFilterProp="label"
      options={CoresVeiculo}
      notFoundContent={<Box>Nenhuma cor encontrada</Box>}
    />
  );
}

export default SelectCorVeiculo;
